import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as AuthAPI from './authAPI';

// 새로고침 이후 임시 로그인 처리. check 액션으로 바로 처리하면 화면 깜빡임 발생.
export const tempSetUser = createAsyncThunk('user/tempSetUser', async (user, { rejectWithValue }) => {
    return user;
});

// 회원 정보 확인
export const check = createAsyncThunk('user/check', async (_, { rejectWithValue }) => {
    try {
        const response = await AuthAPI.check();
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});

// 로그아웃
export const logout = createAsyncThunk('user/logout', async (_, { rejectWithValue }) => {
    try {
        await AuthAPI.logout();
        localStorage.removeItem('user');
        return null;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});

const initialState = {
    user: null,
    checkError: null,
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(tempSetUser.fulfilled, (state, action) => {
                state.user = action.payload;
            })
            .addCase(check.fulfilled, (state, action) => {
                state.user = action.payload;
                state.checkError = null;
            })
            .addCase(check.rejected, (state, action) => {
                state.user = null;
                state.checkError = action.payload;
                localStorage.removeItem('user');  // check 실패 시 localStorage에서 user 정보 삭제
            })
            .addCase(logout.fulfilled, (state) => {
                state.user = null;
            });
    },
});

export default userSlice.reducer;
